<template>
    <v-col>
        <v-row>
            <v-col class="headline">{{ pageTitle }}</v-col>
        </v-row>

        <v-row v-if="!opening">
            <v-col>
                <v-card class="pa-lg-10 pa-md-8 pa-sm-3 pa-2">
                    <v-card-text class="px-lg-10 py-lg-6 px-md-8 py-md-4 pa-sm-3 pa-2">
                        <v-row>
                            <v-col>
                                <v-row>
                                    <v-col>
                                        <v-btn color="primary" @click="refresh">{{ $t("Refresh") }}</v-btn>
                                    </v-col>
                                </v-row>
                                <v-row v-for="account_member in account_members_sorted" :key="account_member.person_id">
                                    <v-col class="col-lg-5 col-md-5 col-sm-7 col-12 py-2">
                                        <AccountChip
                                            :account="account_member.person"
                                            :show-is-primary="false"
                                            :base-url="baseUrl"
                                        ></AccountChip>
                                    </v-col>
                                    <v-col class="col-md-2 col-sm-3 col-8 py-2">
                                        <span style="line-height: 32px;" class="subtitle-1">
                                            {{ account_member.role }}
                                        </span>
                                    </v-col>
                                </v-row>
                                <v-row v-for="client_member in client_members_sorted" :key="client_member.person_id">
                                    <v-col class="col-lg-5 col-md-5 col-sm-7 col-12 py-2">
                                        <AccountChip
                                            :account="client_member.member"
                                            :show-is-primary="false"
                                            :base-url="baseUrl"
                                        ></AccountChip>
                                    </v-col>
                                    <v-col class="col-md-2 col-sm-3 col-8 py-2">
                                        <span style="line-height: 32px;" class="subtitle-1">
                                            {{ client_member.role }}
                                        </span>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="subtitle-1 mt-4">
                                        {{ $t("Security object id") }}:
                                        <span class="font-weight-medium">{{ security_object.id }}</span>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="caption">{{ $t("Members") }}</v-col>
                                    <v-col class="caption">{{ $t("Direct rights") }}</v-col>
                                    <v-col class="caption">{{ $t("Computed rights") }}</v-col>
                                </v-row>
                                <v-row v-for="security_right in security_rights_sorted" :key="security_right.id">
                                    <v-col>
                                        <span
                                            v-if="security_right.person"
                                            class="font-weight-medium grey--text text--darken-4"
                                        >
                                            {{ security_right.person | format_name }}
                                        </span>
                                        <div
                                            v-else
                                            class="font-weight-medium white--text"
                                            style="width: 32px; background-color: #ff0000; display: inline-block; text-align: center; border-radius: 8px;"
                                        >
                                            ?
                                        </div>
                                        <span class="caption">
                                            {{ security_right.person_id }}
                                        </span>
                                    </v-col>
                                    <v-col>{{ security_right.direct_rights }}</v-col>
                                    <v-col>{{ security_right.rights }}</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import AppModule from "../../store/modules/app";
import AccountChip from "../../components/AccountChip";
import { capitalize } from "@/plugins/formatting";
import errorDialog from "@/views/ErrorDialog/errorDialog"

export default {
    name: "ObjectSecurityView",
    components: {
        AccountChip
    },
    props: {},
    setup(props, ctx) {
        const { fetchSecurityObject, baseUrl } = AppModule();

        const opening = ref(true);
        const security_object = ref(null);
        const account_members = ref([]);
        const client_members = ref([]);

        const pageTitle = computed(function() {
            let route = ctx.root._route;
            return "{0} {1}".format(capitalize(route.params.object), route.params.id);
        });

        const account_members_sorted = computed(function() {
            return account_members.value.sort(function(a, b) {
                if (a.rights < b.rights) return 1;
                if (a.rights > b.rights) return -1;
                return 0;
            });
        });

        const client_members_sorted = computed(function() {
            return client_members.value;
            /*return client_members.value.sort(function(a, b) {
                if (a.rights < b.rights) return 1;
                if (a.rights > b.rights) return -1;
                return 0;
            });*/
        });

        const security_rights_sorted = computed(function() {
            return security_object.value.rights.sort(function(a, b) {
                if (a.rights < b.rights) return 1;
                if (a.rights > b.rights) return -1;
                if (a.direct_rights < b.direct_rights) return 1;
                if (a.direct_rights > b.direct_rights) return -1;
                return 0;
            });
        });

        const load_data = function() {
            let route = ctx.root._route;
            fetchSecurityObject({ object: route.params.object, id: route.params.id })
                .then(function(resp) {
                    security_object.value = resp.security_object;
                    account_members.value = resp.account_members ? resp.account_members : [];
                    client_members.value = resp.client_members ? resp.client_members : [];
                    opening.value = false;
                })
                .catch(function(ex) {
                    errorDialog.showError(ex);
                });
        };

        const refresh = function() {
            load_data();
        };

        load_data();

        return {
            pageTitle,
            account_members_sorted,
            client_members_sorted,
            security_rights_sorted,
            opening,
            baseUrl,
            security_object,
            refresh
        };
    }
};
</script>
